import React, { ReactNode } from 'react';
import styles from './AdminProjectDetailQuestionnaires.module.scss';
import AdminProjectDetailCard from '../AdminProjectDetailCard/AdminProjectDetailCard';
import { useTranslate } from 'react-translate.ts';
import Icon from '../../../../common/components/Icon/Icon';
import ProjectQuestionnaire from '../../../types/project/ProjectQuestionnaire';
import { Skeleton } from '@tcc-online/common-components';
import { AdminTableRow } from '../../AdminTable/AdminTable';

type AdminProjectDetailQuestionnairesProps = {
    questionnaires: ProjectQuestionnaire[];
    loading?: boolean;
    children?: ReactNode;
};

const skeletonComponent = Array.from(new Array(5), (_, index: number) => (
    <Skeleton height={40} key={index} className={styles.skeleton} />
));

export default function AdminProjectDetailQuestionnaires(
    props: AdminProjectDetailQuestionnairesProps,
) {
    const { questionnaires, loading, children } = props;
    const translate = useTranslate();
    return (
        <AdminProjectDetailCard title={translate('Vybrané dotazniky')}>
            <AdminTableRow />
            {!loading ? (
                <>
                    {questionnaires.map((questionnaire) => (
                        <AdminTableRow className={styles.item}>
                            <Icon name={`${questionnaire.internalName}.svg`} />
                            <div className={styles.name}>
                                {questionnaire.name}
                            </div>
                        </AdminTableRow>
                    ))}
                    {children}
                </>
            ) : (
                skeletonComponent
            )}
        </AdminProjectDetailCard>
    );
}
